import React, { useState, useEffect } from 'react';
import SplashScreen from './pages/SplashScreen/SplashScreen';
import AppRoutes from './routes/AppRoutes';
import { ThemeProvider } from './hooks/useTheme';
import './styles/global.css';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Always show splash for 3.5 seconds
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider>
      {showSplash ? (
        <SplashScreen onComplete={() => setShowSplash(false)} />
      ) : (
        <AppRoutes />
      )}
    </ThemeProvider>
  );
}

export default App;